import { Flag } from '@src/components';
import { Image, Skeleton } from 'antd';
import { ArrowLeft } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';

interface PackageHeaderSecondVersionProps {
  type: 'country' | 'region';
  name?: string;
  image?: string;
  flag?: string;
}

export function PackageHeaderSecondVersion({
  type = 'country',
  name,
  image,
  flag,
}: Readonly<PackageHeaderSecondVersionProps>) {
  const navigate = useNavigate();

  return (
    <div className='w-full'>
      {(name || flag) && (
        <div className='flex items-center justify-between mb-4 md:hidden'>
          {name && (
            <div className='flex items-center gap-2 max-w-[70%]'>
              <ArrowLeft
                className='cursor-pointer text-wl-on-background'
                onClick={() => navigate(-1)}
              />
              <span className='font-inter text-lg font-normal text-wl-on-background'>
                {name}
              </span>
            </div>
          )}
          {flag && (
            <div className='bg-white bg-opacity-80 p-1.5 rounded-full'>
              <Flag flagSrc={flag} className='w-10 h-10' />
            </div>
          )}
        </div>
      )}

      {image && (
        <div
          className='
            h-[250px] overflow-hidden bg-gray-50 dark:bg-black relative
            -mx-7 md:mx-0 
            rounded-none md:rounded-2xl
          '
        >
          <Image
            src={image}
            alt={name}
            className='w-full h-full object-cover'
            placeholder={<Skeleton.Image active className='!w-full !h-full' />}
            preview={false}
            width='100%'
            height='100%'
          />

          <div className='hidden md:flex absolute top-0 left-0 right-0 pt-6 px-6 items-center justify-between'>
            {name && (
              <div className='flex items-center gap-2 z-10 max-w-[60%]'>
                <ArrowLeft
                  className='cursor-pointer text-wl-on-background'
                  onClick={() => navigate(-1)}
                />
                <span className='font-inter text-lg font-normal text-wl-on-background'>
                  {name}
                </span>
              </div>
            )}
            {flag && (
              <div className='z-10 bg-white bg-opacity-80 p-1.5 rounded-full'>
                <Flag flagSrc={flag} className='w-12 h-12' />
              </div>
            )}
          </div>

          <div
            className={`hidden md:block absolute left-0 top-0 bottom-0 ${
              type === 'country' ? 'w-1/2' : 'w-1/2'
            } bg-gradient-to-r from-gray-50 dark:from-black to-transparent pointer-events-none`}
          />
        </div>
      )}
    </div>
  );
}
